import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import colorSchemes from "../../constants/colorSchemes";
import LoginForm from "../components/SignIn/LoginForm";
import routes from "../../constants/routes";

// Asks a logged-out visitor to sign in without leaving the auction page.
// Closing it lets them keep browsing as a guest.
const LoginDialog = ({
  open,
  onClose,
  onLogin,
  redirectPath,
  title = "Sign in to bid",
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "600",
          color: colorSchemes.primaryColor,
          pr: 6,
        }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <LoginForm
          onSuccess={onLogin}
          redirectAfterSocialLogin={redirectPath}
          registerPath={routes.bidderRegister}
        />
        <Button fullWidth onClick={onClose} sx={{ mt: 1, color: "#7E8184" }}>
          Continue as guest
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default LoginDialog;
